import { render, staticRenderFns } from "./ItemHeader.vue?vue&type=template&id=4abf1130&scoped=true&"
import script from "./ItemHeader.vue?vue&type=script&lang=js&"
export * from "./ItemHeader.vue?vue&type=script&lang=js&"
import style0 from "./ItemHeader.vue?vue&type=style&index=0&id=4abf1130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abf1130",
  null
  
)

export default component.exports